/* eslint import/prefer-default-export: 0 */

export const MOBILE_HEADER_SET_VISIBILITY = 'MOBILE_HEADER_SET_VISIBILITY';
export const MOBILE_MENU_SET_VISIBILITY = 'MOBILE_MENU_SET_VISIBILITY';
export const START_MAINTENANCE_MODE = 'START_MAINTENANCE_MODE';
export const FINISH_MAINTENANCE_MODE = 'FINISH_MAINTENANCE_MODE';
export const OPEN_APP_FLYOUT = 'app/OPEN_APP_FLYOUT';
export const CLOSE_APP_FLYOUT = 'app/CLOSE_APP_FLYOUT';
export const APP_FLYOUT_IS_OPENED = 'app/APP_FLYOUT_IS_OPENED';
export const APP_FLYOUT_IS_CLOSED = 'app/APP_FLYOUT_IS_CLOSED';
export const UPDATE_APP_FLYOUT = 'app/UPDATE_APP_FLYOUT';
